import type { ReportingTooltipEntry } from "@/components/reporting/charts"

// A stacked bar only carries the resolved count, so the share behind it travels
// on the point under `rates`, keyed by channel.
export const channelResolutionRate = (
	entry: ReportingTooltipEntry,
): number | null => {
	const rates = entry.payload?.rates
	if (typeof rates !== "object" || rates === null) return null
	const rate = (rates as Record<string, unknown>)[String(entry.dataKey ?? "")]
	return typeof rate === "number" ? rate : null
}

export const formatResolutionRate = (rate: number): string =>
	`${Math.round(rate * 10) / 10}%`
